import { render } from "./ServiceLevelDetailsReport.vue?vue&type=template&id=4ddce8b6"
import script from "./ServiceLevelDetailsReport.vue?vue&type=script&lang=js"
export * from "./ServiceLevelDetailsReport.vue?vue&type=script&lang=js"

import "./ServiceLevelDetailsReport.vue?vue&type=style&index=0&id=4ddce8b6&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__